import { GUID } from 'core/utils';
import * as ActionTypes from '../models/actions';
import * as ActionNames from '../models/actions/names';
import {
  FocusedInputparaphraseModel,
  GetLocalStorageDataModel,
  LastParaphrasedTextData,
} from '../models/store';

export const showTncDialog = (value: boolean): ActionTypes.ShowTncDialog => ({
  type: ActionNames.SHOW_TNC_DIALOG,
  payload: value,
});

export const setOutputBoxEditableForMobile = (
  value: boolean
): ActionTypes.OutputBoxEditableForMobile => ({
  type: ActionNames.OUTPUTBOX_EDITABLE_MOBILE,
  payload: {
    value,
  },
});

export const setUploadFileInfo = (value: {
  fileName: string;
  fileType: string;
}): ActionTypes.SetUploadFileInfo => ({
  type: ActionNames.SET_UPLOAD_FILE_INFO,
  payload: {
    value,
  },
});

export const completedSentenceParaphrasing = (): ActionTypes.NumberOfCompletedParaphrases => ({
  type: ActionNames.SET_NUMBER_OF_COMPLETED_PARAPHRASES,
});

export const setShowCharLimitMessage = (value: boolean): ActionTypes.ShowCharLimitMessage => ({
  type: ActionNames.SET_SHOW_CHAR_LIMIT_MESSAGE,
  payload: {
    value,
  },
});

export const setStartedQuilling = (value: boolean): ActionTypes.SetStartedQuilling => ({
  type: ActionNames.SET_STARTED_QUILLING,
  payload: {
    value,
  },
});

export const setShowRequillLabel = (value: boolean): ActionTypes.SetShowRequillLabel => ({
  type: ActionNames.SET_SHOW_REQUILL_LABEL,
  payload: {
    value,
  },
});

export const setInputSentences = (value: {
  inputId: string;
  sentenceList: Array<any>;
}): ActionTypes.SetInputSentences => ({
  type: ActionNames.SET_INPUT_SENTENCES,
  payload: {
    value,
  },
});

export const setFocusedInputParaphrase = (
  value: FocusedInputparaphraseModel | null
): ActionTypes.SetFocusedInputParaphrase => ({
  type: ActionNames.SET_FOCUSED_INPUT_PARAPHRASER,
  payload: {
    value,
  },
});

export const setInputText = (value: string): ActionTypes.SetInputText => ({
  type: ActionNames.SET_INPUT_TEXT,
  payload: {
    value,
  },
});

export const setCyrillicFreeText = (value: string): ActionTypes.SetCyrillicFreeText => ({
  type: ActionNames.SET_CYRILLIC_FREE_TEXT,
  payload: {
    value,
  },
});

export const userClickedTrySample = (): ActionTypes.UserClickedTrySample => ({
  type: ActionNames.USER_CLICKED_TRY_SAMPLE,
});

export const setQuillConfigOpenMobile = (value: boolean): ActionTypes.SetQuillConfigOpenMobile => ({
  type: ActionNames.SET_QUILL_CONFIG_OPEN_MOBILE,
  payload: {
    value,
  },
});

export const setOutputParaphraserUpdater = (
  value: Array<any>
): ActionTypes.SetOutputParaphraserUpdater => ({
  type: ActionNames.SET_OUTPUT_PARAPHRASER_UPDATER,
  payload: value,
});

export const setCompareModeUpdater = (): ActionTypes.SetCompareModeUpdater => ({
  type: ActionNames.SET_COMPARE_MODE_UPDATER,
});

export const setStrength = (value: number): ActionTypes.SetStrength => ({
  type: ActionNames.SET_STRENGTH,
  payload: {
    value,
  },
});

export const setShowLegend = (value: boolean): ActionTypes.SetShowLegend => ({
  type: ActionNames.SET_SHOW_LEGEND,
  payload: {
    value,
  },
});

export const setYellowToHighlightSentence = (
  value: boolean
): ActionTypes.SetYellowToHighlightSentence => ({
  type: ActionNames.SET_YELLOW_TO_HIGHLIGHT_SENTENCE,
  payload: {
    value,
  },
});

export const setShowLongestUnchangedWordColor = (
  value: boolean
): ActionTypes.SetShowLongestUnchangedWordColor => ({
  type: ActionNames.SET_SHOW_LONGEST_UNCHANGED_WORD_COLOR,
  payload: {
    value,
  },
});

export const setShowChangeWordColor = (value: boolean): ActionTypes.SetShowChangeWordColor => ({
  type: ActionNames.SET_SHOW_CHANGE_WORD_COLOR,
  payload: {
    value,
  },
});

export const setShowSentenceRestructureLine = (
  value: boolean
): ActionTypes.SetShowSentenceRestructureLine => ({
  type: ActionNames.SET_SHOW_SENTENCE_RESTRUCTURE_LINE,
  payload: {
    value,
  },
});

export const showContextModel = (value: boolean): ActionTypes.ShowContextModel => ({
  type: ActionNames.SET_SENTENCE_SPLITTER_CONTEXT_MESSAGE,
  payload: {
    value,
  },
});

export const userResettedParaphraseState = (): ActionTypes.UserResettedParaphraseState => ({
  type: ActionNames.USER_RESETTED_PARAPHRASE_STATE,
});

export const userFinishedTyping = (): ActionTypes.UserFinishedTyping => ({
  type: ActionNames.USER_FINISHED_TYPING,
  payload: {
    value: GUID(),
  },
});

export const userChangedSentenceLockedStatus = (
  value: number
): ActionTypes.UserChangedSentenceLockedStatus => ({
  type: ActionNames.USER_CHANGED_SENTENCE_LOCK_STATUS,
  payload: {
    value: value,
  },
});

export const setUserOnboarding = (value: boolean): ActionTypes.SetUserOnboardingStatus => ({
  type: ActionNames.USER_ONBOARDING_STATUS,
  payload: {
    value: value,
  },
});

export const setUserOnboardingFromCookie = (
  value: any
): ActionTypes.SetUserOnboardingFromCookie => ({
  type: ActionNames.USER_ONBOARDING_STATUS,
  payload: {
    value: value,
  },
});

export const setUserOnboardingStep = (value: string): ActionTypes.SetUserOnboardingStep => ({
  type: ActionNames.USER_ONBOARDING_STEP,
  payload: {
    value: value,
  },
});

export const getLocalStorageData = (
  value: GetLocalStorageDataModel
): ActionTypes.GetLocalStorageData => ({
  type: ActionNames.GET_LOCAL_STORAGE_DATA,
  payload: value,
});

export const setLastParaphrasedText = (
  value: LastParaphrasedTextData
): ActionTypes.SetLastParaphrasedText => ({
  type: ActionNames.UNDO_LAST_PARAPHRASED_STATE,
  payload: value,
});

export const setFreezeWords = (freezeWords: string[]): ActionTypes.SetFreezeWords => ({
  type: ActionNames.SET_FREEZE_WORDS,
  payload: freezeWords,
});

export const changedWordFlipper = (wordFlipperValue: number): ActionTypes.ChangedWordFlipper => ({
  type: ActionNames.USER_CHANGED_WORD_FLIPPER,
  wordFlipperValue,
});

export const setBeams = (strength: number, beamSet: Array<string>): ActionTypes.SetBeams => ({
  type: ActionNames.SET_BEAMS,
  payload: { strength, beamSet },
});

export const setDialogState = (dialogOpenState: boolean): ActionTypes.SetDialogState => ({
  type: ActionNames.IS_DIALOG_OPEN,
  payload: dialogOpenState,
});

export const setRephraseTooltip = (state: boolean): ActionTypes.SetRephraseTooltip => ({
  type: ActionNames.SET_REPHRASE_TOOLTIP,
  payload: state,
});

export const setSentenceControlToolBarState = (
  state: boolean
): ActionTypes.SetSentenceControlState => ({
  type: ActionNames.SET_SENTENCE_CONTROL_TOOLBAR_STATE,
  payload: state,
});

export const setMergeModalState = (state: boolean): ActionTypes.SetMergeModalState => ({
  type: ActionNames.SET_MERGE_MODAL_STATE,
  payload: state,
});

export const showPersistedSentenceControl = (
  payload: boolean
): ActionTypes.ShowPersistedSentenceControl => ({
  type: ActionNames.SHOW_PERSISTED_SENTENCE_CONTROL,
  payload,
});
